import { useMinCopy } from '@/i18n/useUiLocale'
import { cn } from '@/components/ui/cn'

/** Lexio wordmark + Beta pill (Nearby-style stage badge). */
export function BrandMark({
  className,
  nameClassName,
  showTagline = false,
}: {
  className?: string
  nameClassName?: string
  showTagline?: boolean
}) {
  const { brand } = useMinCopy()
  const NameTag = showTagline ? 'h1' : 'span'

  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        <NameTag className={cn('text-xl font-bold text-primary', nameClassName)}>{brand.name}</NameTag>
        <span
          className="inline-flex shrink-0 items-center rounded-full border border-primary/35 bg-primary/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-primary"
          data-testid="brand-beta-badge"
        >
          {brand.beta}
        </span>
      </div>
      {showTagline ? (
        <p className="mt-0.5 text-xs text-muted-foreground">{brand.tagline}</p>
      ) : null}
    </div>
  )
}
